<template>
    <div class="vod-sidebar" :class="{ '-extended': sidebarExtended }">
        <div
            class="vod-sidebar-modal"
            v-if="sidebarExtended"
            @click="toggleSidebar"
        ></div>
        <div class="vod-sidebar-content">
            <img src="@/assets/img/logos/vod_logo.svg" />
            <VodLoginForm
                @logged="toggleSidebar"
                @register="goToRegister"
                @close="toggleSidebar"
                v-if="formType == 'login'"
            />
            <VodRegisterForm
                @hideWarning="toggleSidebar"
                @close="toggleSidebar"
                v-if="formType == 'register'"
            />
            <VodForgot v-if="formType == 'forgot'" />
        </div>
    </div>
</template>
<script>
import VodLoginForm from './VodLoginForm'
import VodRegisterForm from './VodRegisterForm'
import VodForgot from './VodForgot'
export default {
    components: {
        VodLoginForm,
        VodRegisterForm,
        VodForgot
    },
    computed: {
        formType() {
            return this.$store.state.sidebarForm
        },
        sidebarExtended() {
            return this.$store.state.sidebarExtended
        }
    },
    methods: {
        goToRegister() {
            this.$store.commit('setSidebarForm', 'register')
        },
        toggleSidebar() {
            this.$store.dispatch('toggleSidebar')
        }
    }
}
</script>
<style lang="scss" scoped>
.vod-sidebar {
    position: fixed;
    top: 0;
    left: -40vw;
    height: 100%;
    width: 40vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5rem;
    transition: $ease;
    border-right: 1px solid #999999;
    z-index: $high;
    overflow-y: auto;
    background: var(--background);

    &.-extended {
        left: 0;
    }
}
.vod-sidebar-modal {
    z-index: $low;
    position: fixed;
    top: 0;
    left: 40vw;
    width: 100vw;
    height: 100vw;
}
.vod-sidebar-content {
    z-index: $high;
    position: relative;
    width: 60%;
    min-width: 300px;
    max-width: 100% !important;

    img {
        width: 100%;
    }
}
@media (max-width: 1000px) {
    .vod-sidebar {
        left: -100vw;
        width: 100vw;
        border: none;
        padding: 5rem 2rem;

        &.-extended {
            left: 0;
        }
    }
    .vod-sidebar-content {
        width: 100%;
    }
}
</style>
